module.exports = __webpack_public_path__ + "static/media/bag.8eaf5f7e.svg";